import { useEffect, useState } from "react";
import { Section, SectionHead } from "@/components/landing/Section";
import { EscapadeCard } from "@/components/EscapadeCard";
import { http } from "@/lib/api";

const PROFILE = { solo: "Solo", couple: "Couple", famille: "Famille" };

const Context = ({ e }) => (
  <p className="mb-3 min-h-[2.5rem] font-mono text-[11px] uppercase tracking-widest text-gray-500">
    Depuis {e.departure_city} · {PROFILE[e.profile]} · {e.travelers} pers. · {e.duration} j · {e.user_budget} € max
  </p>
);

export const RealExamples = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { http.get("/examples").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items.length) return null;
  return (
    <Section id="exemples-reels">
      <SectionHead eyebrow="Exemples réels" title="Trois recherches, trois vraies escapades">
        Résultats générés par Wanderlust pour un solo, un couple et une famille, depuis trois villes différentes. Cliquez pour voir l'aperçu complet.
      </SectionHead>
      <div data-testid="real-examples-grid" className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        {items.map((e, i) => (
          <div key={e.id} data-testid={`real-example-${i + 1}`} className="flex flex-col">
            <Context e={e} />
            <EscapadeCard e={e} index={i} />
          </div>
        ))}
      </div>
    </Section>
  );
};
